import { Create } from "react-admin";
import { NotificationCentralWrapper } from "./notification_create/index.js";

export const NotificationCreate = (props) => {
  return (
  <Create title="Criação Notificação de Email" {...props}>
    <NotificationCentralWrapper history={props.history} />
  </Create>
);}
